export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function validateUrl(urlReview, attribute) {
  if (attribute == 'class' && urlReview == null) {
    return ' void-link';
  }

  if (attribute == 'index' && urlReview != null) {
    return 'tabindex="0"';
  }

  return '';
}

export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function openNewTab(isLocal) {
  const urlToValidate = isLocalUrl(isLocal);
  return urlToValidate ? '' : 'target="_blank"';
}

// custom burger menu
export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');
  currentToggle.attr('tabindex', '0').append(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/>
    </svg>
    `);

  openMenuKeyboard();

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

export function updateFooterLogos() {
  $('.footer .affiliate-logos a').each(function () {
    if ($(this).attr('href') == '') {
      $(this).addClass('void-link');
      $(this).attr('tabindex', '1');
      $(this).removeAttr('href');
    }
  });
}

export function customSignup() {
  const signupElement = $('.header .search-container .emailSignup .emailInputSubmit');
  const signupTrigger = $('.footer .footer-buttons #trigger-modal');

  signupTrigger.on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      signupElement.trigger('click');
    }
  });
}
